import { DEFAULT_CACHE_TIME, queryClient, queryClientPersister } from '@api/query-client';
import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ToastContainer } from '@unistocks/components/toast';
import { QUERY_STORAGE_VERSION } from '@unistocks/shared/consts';
import { reduxPersistor, store } from '@unistocks/shared/store';
import { PropsWithChildren } from 'react';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate as ReduxPersistGate } from 'redux-persist/integration/react';
import { ModalProvider } from './modal-context';
import { AppThemeProvider } from './theme';

export function SharedProvider({ children }: PropsWithChildren) {
  return (
    <KeyboardProvider>
      <ReduxProvider store={store}>
        <ReduxPersistGate loading={null} persistor={reduxPersistor}>
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{
              buster: QUERY_STORAGE_VERSION,
              persister: queryClientPersister,
              maxAge: DEFAULT_CACHE_TIME
            }}
          >
            <ModalProvider>
              <AppThemeProvider>
                <BottomSheetModalProvider>{children}</BottomSheetModalProvider>
                <ToastContainer />
              </AppThemeProvider>
            </ModalProvider>
          </PersistQueryClientProvider>
        </ReduxPersistGate>
      </ReduxProvider>
    </KeyboardProvider>
  );
}
